<template>
  <div>
    <div class="toolbar">
      <v-row no-gutters>
        <v-col cols="12" md="8" lg="8">
          <div class="pa-2">
            <v-text-field
              v-model="find"
              placeholder="Type user vendor name"
              @keydown="fetchData"
              hide-details
              color="green"
              dense
              solo
              flat
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="4" md="4">
          <div class="pa-2">
            <v-select
              dense
              hide-details
              :items="showData"
              v-model="limit"
              @change="fetchData"
              placeholder="Rows"
              solo
              flat
              color="green"
            ></v-select>
          </div>
        </v-col>
      </v-row>
    </div>
    <div style="min-height: 200px">
      <div class="pa-2" v-if="!loading">
        <div v-if="dataSet">
          <div v-if="dataSet.length">
            <v-card
              v-for="(item, i) in dataSet"
              :key="i"
              class="pa-3 mb-3"
              elevation="1"
              @click="pickUser(item)"
            >
              <v-row>
                <v-col cols="10">
                  {{ item.name }}
                </v-col>
                <v-col cols="2">
                  <v-icon color="green" v-if="userPicked.id == item.id"
                    >mdi-check</v-icon
                  >
                </v-col>
              </v-row>
            </v-card>
            <div class="text-center pa-3">
              <v-pagination
                v-model="page"
                color="#006341"
                @input="fetchData"
                :length="last_page"
              ></v-pagination>
            </div>
          </div>
          <div v-if="!dataSet.length">
            <p class="default_txt text-center">Cant find '{{ find }}'</p>
          </div>
        </div>
      </div>
      <v-row no-gutters v-if="loading">
        <v-col cols="12" v-for="i in 3" :key="i">
          <div class="mb-2">
            <v-skeleton-loader
              class="rounded_max"
              type="image"
              height="46px"
            ></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-if="userPicked" class="d-flex justify-end">
      <v-btn text @click="assignUser" class="text-capitalize" color="#006341"
        >Invite</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["inventory"],
  computed: {
    ...mapState({
      recipient: (state) => state.blast.recipient,
    }),
  },
  data() {
    return {
      find: "",
      loading: false,
      dataSet: null,
      userPicked: { id: "" },
      inviting: false,
      showData: [5, 10, 20],
      page: 1,
      limit: 15,
      total: null,
      last_page: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  watch: {},
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/cohort?filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}&include=cohortMember`,
      };

      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    pickUser(item) {
      if (this.userPicked.id == item.id) {
        this.userPicked = {
          id: "",
        };
      } else {
        this.userPicked = item;
      }
    },
    assignVar() {
      console.log("-");
    },

    assignUser() {
      let member = this.userPicked.cohort_member.map((el) => {
        return el.cohort_profile;
      });
      this.inventory.group = member;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.card_gb {
  position: relative;
  overflow: hidden;
}
.icon_gb {
  position: absolute;
  right: -20px;
  bottom: -20px;
}
.toolbar {
  background: #edf1f0;
  margin-bottom: 10px;
  border-radius: 5px;
}
</style>